import {
  type AppTemplate,
  DevelopmentTool,
} from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import { getTemplateTabs } from '../../constants/sideBarItems';
import type { TemplateTab } from '../../types/TemplateTabs';

interface GetTemplatesTabsToDisplayProps {
  filterByTab?: TemplateTab;
  displayHarmonyNotifications: boolean;
}

export const getTemplatesTabsToDisplay = ({
  filterByTab,
  displayHarmonyNotifications,
}: GetTemplatesTabsToDisplayProps): TemplateTab[] => {
  const templatesTabs = getTemplateTabs(displayHarmonyNotifications);
  if (filterByTab && templatesTabs.includes(filterByTab as DevelopmentTool)) {
    return [filterByTab];
  }
  return templatesTabs;
};

interface GetTemplateForTabProps {
  templates: AppTemplate[];
  tab: TemplateTab;
}

export const getTemplatesForTab = ({
  templates,
  tab,
}: GetTemplateForTabProps): AppTemplate[] => {
  return templates.filter(
    (template) => !!template.developmentTools?.includes(tab as DevelopmentTool),
  );
};

export const isCliScratchTemplate = (template: AppTemplate): boolean => {
  return (
    !template.previewUrl &&
    template.developmentTools?.includes(DevelopmentTool.CLI)
  );
};

export const isBlocksScratchTemplate = (template: AppTemplate): boolean => {
  return (
    !template.previewUrl &&
    template.developmentTools?.includes(DevelopmentTool.BLOCKS)
  );
};

export const isSelfHostedScratchTemplate = (template: AppTemplate): boolean => {
  return (
    !template.previewUrl &&
    template.developmentTools?.includes(DevelopmentTool.DEV_CENTER)
  );
};
